import React from "react";
import { createBrowserRouter, RouterProvider, useNavigation, useLocation, Outlet, useParams } from "react-router-dom";
import { SidebarProvider, useSidebar } from "./context/SidebarContext";
import Sidebar from "./components/Sidebar";
import Login from "./Login";
import Register from './Register';
import HomePage from './Home';
import NewsPage from './News';
import Chat from "./Chat";
import Profile from "./Profile";
import Password from "./Password";
import Drive from "./Drive";
import ProjectPage from "./ProjectPage";

function ChatWrapper() {
  const { agentType } = useParams();
  return <Chat key={agentType} />;
}

const fetchWithAuth = (url) => {
  const token = localStorage.getItem('token');
  return fetch(url, { headers: { 'Authorization': `Bearer ${token}` } }).then(r => r.json());
};
const generateUUID = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

const PUBLIC_ROUTES = ["/", "/register", "/password"];


function MobileBlock() {
  return (
    <div style={{
      height: "100dvh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: "2rem",
      background: "#0f0f0f",
      color: "#fff",
      fontFamily: "sans-serif"
    }}>
      <span style={{ fontSize: "3rem" }}>🚧</span>
      <h2 style={{ marginTop: "1rem" }}>Versão mobile em desenvolvimento</h2>
      <p style={{ color: "#aaa", marginTop: "0.5rem" }}>
        Acesse pelo computador por enquanto.<br />Em breve estará disponível no celular!
      </p>
    </div>
  );
}

function RootLayout() {
  const navigation = useNavigation();
  const location = useLocation();
  const isLoading = navigation.state === 'loading';
  const { sidebarOpen } = useSidebar();

  const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname);


  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
       {!isPublicRoute && <Sidebar />}

      {/* Conteúdo empurrado pelo sidebar */}
      <div style={{
        flex: 1,
        marginLeft: sidebarOpen ? '15vw' : '0px',
        transition: 'margin-left 0.25s ease',
        position: 'relative',
      }}>
        {isLoading && (
          <div style={{
            position: 'fixed', inset: 0, backgroundColor: '#000',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', zIndex: 9999
          }}>
            <div style={{ position: 'relative', width: '100px', height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ width: '12px', height: '12px', backgroundColor: '#007AFF', borderRadius: '50%', zIndex: 2 }} />
              <div className="ripple" style={{ animationDelay: '0s' }} />
              <div className="ripple" style={{ animationDelay: '1s' }} />
              <div className="ripple" style={{ animationDelay: '2s' }} />
            </div>
            <h2 style={{ color: '#fff', marginTop: '40px', fontWeight: '300', fontFamily: 'sans-serif', letterSpacing: '2px', opacity: 0.8 }}>
              Indo às profundezas...
            </h2>
            <style>{`
              .ripple {
                position: absolute;
                border: 2px solid #007AFF;
                opacity: 0;
                border-radius: 50%;
                width: 10px;
                height: 10px;
                animation: ripple-effect 3s linear infinite;
              }
              @keyframes ripple-effect {
                0% { width: 10px; height: 10px; opacity: 0.8; }
                100% { width: 250px; height: 250px; opacity: 0; border-width: 1px; }
              }
            `}</style>
          </div>
        )}
        <Outlet />
      </div>
    </div>
  );
}

const router = createBrowserRouter([
  {
    Component: () => (
      <SidebarProvider>
        <RootLayout />
      </SidebarProvider>
    ),
    children: [
      { path: "/", Component: Login },
      { path: "/register", Component: Register },
      { path: "/password", Component: Password },
      {
        path: "/home",
        loader: () => fetchWithAuth("https://hubdaive.com.br/api/news"),
        Component: HomePage,
      },
      {
        path: "/news",
        loader: () => fetchWithAuth("https://hubdaive.com.br/api/news"),
        Component: NewsPage,
      },
      {
        path: "/chat/:agentType",
        loader: async ({ params }) => {
          const token = localStorage.getItem('token');
          const userUUID = localStorage.getItem('user_id');
          const lastThreadId = localStorage.getItem('lastChatId') || generateUUID();

          const [sessionsRes, historyRes] = await Promise.all([
            fetch("https://hubdaive.com.br/api/conversations", {
              headers: { "Authorization": `Bearer ${token}` }
            }),
            fetch(
              params.agentType === 'agente-gov'
                ? `https://hubdaive.com.br/api/agente-gov/history/${lastThreadId}`
                : `https://hubdaive.com.br/api/agente-pesquisa/history/${lastThreadId}?user_id=${userUUID}`,
              { headers: { "Authorization": `Bearer ${token}` } }
            )
          ]);

          const sessionsData = await sessionsRes.json();
          const historyData = await historyRes.json();

          return { sessionsData, historyData, initialThreadId: lastThreadId };
        },
        element: <ChatWrapper />,
      },
      { path: "/projects/:project_id",
        Component: ProjectPage
      },
      {
        path: "/profile",
        Component: Profile,
      },
      { path: "/drive", 
        Component: Drive },
    ]
  }
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;